/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import * as actionTypes from './RewardPoints-ActionTypes';

export const loadRewardsEligibility = () => ({
    type: actionTypes.LOAD_REWARDS_POINTS_ELIGIBILITY,
});

export const setRewardsEligibility = (data) => ({
    type: actionTypes.SET_REWARDS_POINTS_ELIGIBILITY,
    data,
});

export const loadRewardsPoints = () => ({
    type: actionTypes.LOAD_REWARDS_POINTS,
});

export const setRewardsPoints = (data) => ({
    type: actionTypes.SET_LOAD_REWARDS_POINTS,
    data,
});

export const setSelectedPointsRewards = (amount, points) => ({
    type: actionTypes.SET_SELECTED_REWARDS_POINTS,
    data: {
        amount,
        points,
    },
});

export const clearAllRewardsPoints = () => ({
    type: actionTypes.CLEAR_ALL_REWARDS_POINTS,
});

export const clearSelectedRewardsPoints = () => ({
    type: actionTypes.CLEAR_SELECTED_REWARDS_POINTS,
});
